import type {ReviewsListRatingBreakdownItemData} from '@frontend/modules/public/shared/reviews/ReviewsModuleTypes'
import {RatingStars} from 'swayok-react-mdb-ui-kit/components/Icon/RatingStars'
import {Progress} from 'swayok-react-mdb-ui-kit/components/Progress/Progress'
import {ProgressBar} from 'swayok-react-mdb-ui-kit/components/Progress/ProgressBar'

interface Props {
    ratingBreakdown: ReviewsListRatingBreakdownItemData[] | null
    reviewsCount: number
}

// Распределение оценок рейтинга пользователя/исполнителя услуг.
export function ReviewsListRatingBreakdown(props: Props) {

    console.log(props)

    const {
        ratingBreakdown,
        reviewsCount,
    } = props

    if (!ratingBreakdown) {
        return null
    }

    return (
        <table className="table table-borderless table-sm mt-1">
            <tbody>
                {ratingBreakdown.map((rateInfo: ReviewsListRatingBreakdownItemData, index: number) => (
                    <tr key={'rating-summary-' + index}>
                        <td className="ps-0 pe-3 py-1 align-middle">
                            <RatingStars
                                rating={rateInfo.rating}
                                starSize={20}
                                inactiveIconColor="light-gray"
                            />
                        </td>
                        <td className="full-width px-0 py-1 align-middle">
                            <Progress height={6}>
                                <ProgressBar
                                    currentValue={rateInfo.count}
                                    maxValue={reviewsCount}
                                    color="dark"
                                />
                            </Progress>
                        </td>
                        <td className="ps-4 pe-0 py-1 align-middle text-end">
                            {rateInfo.count}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}
